var React = require('react');

function CloseLarge (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.65 2.35a1.199 1.199 0 00-1.696 0L8.007 6.299 4.061 2.35a1.199 1.199 0 00-1.695 1.695l3.947 3.947-3.947 3.946a1.2 1.2 0 101.695 1.695l3.946-3.947 3.947 3.947a1.199 1.199 0 001.695-1.695L9.702 7.993l3.947-3.947a1.198 1.198 0 000-1.695z","fill":"currentColor"}));
}

CloseLarge.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = CloseLarge;

CloseLarge.default = CloseLarge;
